import { makeStyles } from 'tss-react/mui';

const useStylesSecretKeyBlock: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  secretKeyBlockFieldContainer: {
    width: '100%',
    '& > div': {
      width: '100%',
    },
  },
  secretKeyBlockFieldContainerHidden: {
    margin: '15px 0',
  },
}));

export default useStylesSecretKeyBlock;
